import axios from "axios";
import config from "app/api/axiosConfig";

export default (id: number, token: string) =>
	axios.delete(`${process.env.REACT_APP_CHAT_HOST}/Api/Notifications/${id}`, config(token))
